import React from "react";
import { Card, Table, Row, Col, Breadcrumb } from "react-bootstrap";
import PlanHeader from "./PlanHeader";
import { useState, useEffect } from "react";
import { getStatement } from "../../../../../apis/options/PlanApi";
import StmtIssueGroup from "./PlanStatementOption";
import { useHistory } from "react-router-dom";
import { Button } from "react-bootstrap";

export default function PlanStatement({planId}) {

    const history = useHistory();

    const [statement, setStatement] = useState(null);
    const [stmtIsLoading, setStmtIsLoading] = useState(true);

    useEffect(() => {
        async function getStatementData() {
            try {
                const stmt = await getStatement(planId);
                setStatement(stmt);
                setStmtIsLoading(false);
            }
            catch(error) {
                setStmtIsLoading(false);
            }
        }

        getStatementData();

    }, [planId]);

    const goToSummary = _ =>
    {
        history.push("/options/plans/summary");
    }

    const goToUpdate = () => {
        history.push(`/options/plans/${planId}/edit`);
    }

    const goToAddGroup = () => {
        history.push(`/options/plans/${planId}/groups/add`)
    }

    return (
        <>
        {!stmtIsLoading ? 
        <>
            <Row>
                <Col>
                    <Breadcrumb>
                        <Breadcrumb.Item onClick={goToSummary}>Summary</Breadcrumb.Item>
                        <Breadcrumb.Item active>{statement.name}</Breadcrumb.Item>
                    </Breadcrumb>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Button onClick={goToUpdate}>Edit Plan</Button>
                </Col>
            </Row>
            <Row className="">
                <Col>
                    <Card style={{marginTop: 25}}>
                        <Card.Body>
                            <Card.Title>{statement.name}</Card.Title>
                            <Row className="justify-content-end">
                            <PlanHeader planSummary={statement.summary} /> 
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Card style={{marginTop: 25}}>
                        <Card.Body>
                            <Card.Title>Plan Details
                                <Button onClick={goToAddGroup}>New Issue Group</Button>
                            </Card.Title>
                            <Row>
                                <Table hover responsive style={{fontSize: 12, overflowY: "auto", height: 300}} >
                                    <thead style={{position: "sticky", top: 0}}>
                                    <tr>
                                        <th>Employee</th>
                                        <th>Issued</th>
                                        <th className="text-center"><div>Total</div><div>Options</div></th>
                                        <th className="text-center"><div>Vested %</div></th>
                                        <th className="text-center"><div>Vested</div><div>Options</div></th>
                                        <th className="text-center"><div>Strike</div><div>Price</div></th>
                                        <th className="text-center"><div>Price</div><div>Difference</div></th>
                                        <th className="text-center"><div>Vested</div><div>Value</div></th>
                                        <th className="text-center"><div>Expiration</div><div>Date</div></th>
                                        <th className="text-center"><div>Notes</div></th>
                                    </tr>
                                    </thead>
                                    {statement.issueGroups.length > 0 ?
                                    statement.issueGroups.map(d => (
                                        <StmtIssueGroup key={d.issueGroupId} planId={planId} issueGroup={d} />                   
                                    ))
                                    : <tbody><tr><td>There are no groups in this plan yet...</td></tr></tbody>}                                
                                </Table>                    
                            </Row>                
                        </Card.Body>
                    </Card>                     
                </Col>
            </Row>
        </>
        : <Row><Col>Loading Statement...</Col></Row>}
        </>
    );
}